import PropTypes from 'prop-types'
import React from 'react'
import Scroll from 'react-scroll'
import './styles.css'

function Address({
  firstName = '',
  lastName = '',
  streetAddress = '',
  extendedAddress = '',
  locality = '',
  region = '',
  postalCode = '',
  countryName = '',
  amount = 1,
  edit,
  remove
}) {
  const scrollOffset = (amount - 1) * -102

  return (
    <div className="address">
      <div className="address-body">
        <div className="name-header">
          <div className="name">{firstName} {lastName}</div>
        </div>
        <div className="address-description">
          <span>{streetAddress}, {`${extendedAddress ? `${extendedAddress},` : ''} ${locality}, ${region} ${postalCode}, ${countryName}.`}</span>
        </div>
      </div>
      <div className="cta">
        <div className="edit">
          <Scroll.Link to="modifyAddress" spy smooth duration={500} offset={scrollOffset}>
            <button type="button" onClick={() => edit()}>edit</button>
          </Scroll.Link>
        </div>
        <div className="remove">
          <div className="remove-btn-container">
            <div
              onClick={() => remove()}
              onKeyDown={(e) => e.key === 'Enter' && remove()}
              className="cross"
              role="button"
              tabIndex={0}
            >
              <i className="icon-x" />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export const addressProptypes = {
  countryCodeAlpha2: PropTypes.string,
  countryName: PropTypes.string,
  extendedAddress: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  locality: PropTypes.string,
  postalCode: PropTypes.string,
  region: PropTypes.string,
  streetAddress: PropTypes.string
}

Address.propTypes = {
  ...addressProptypes,
  id: PropTypes.number.isRequired,
  remove: PropTypes.func.isRequired,
  edit: PropTypes.func.isRequired,
  amount: PropTypes.number
}

export default Address
